module.exports = __webpack_public_path__ + "static/media/26UNRWA20.b112511f.jpg";